module.exports = __webpack_public_path__ + "static/customer_photo_6-d42f3e81b2e1bd867711775f83ec12da.jpg";